class CollectionLinksRowComponent extends HTMLElement {
  connectedCallback() {
    if (this.getAttribute('reveal') !== 'true') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.items = Array.from(this.querySelectorAll('[data-reveal-item]'));
    if (!this.items.length) return;

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            this.observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2, rootMargin: '0px 0px -10% 0px' }
    );

    this.items.forEach((item) => this.observer.observe(item));
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

if (!customElements.get('collection-links-row-component')) {
  customElements.define('collection-links-row-component', CollectionLinksRowComponent);
}